import React from 'react';
import { render } from 'react-dom';

import OneThirdContentBlock from '../react/OneThirdContentBlock';

export default class OneThirdContentBlockRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<OneThirdContentBlock data={jsonModel} />, this.context);
  }
}
